import { CSSProperties } from 'react';

export function BaseLogo({ size = 16, style }: { size?: number; style?: CSSProperties }) {
	return (
		<svg
			version="1.1"
			width={size}
			height={size}
			style={style}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 2500 2500"
			fill="none"
		>
			<g clipPath="url(#clip0_15_3)">
				<mask
					id="mask0_15_3"
					style={{ maskType: 'luminance' }}
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="2500"
					height="2500"
				>
					<path
						d="M1250 2500C559.6 2500 0 1940.4 0 1250C0 559.6 559.6 0 1250 0C1940.4 0 2500 559.6 2500 1250C2500 1940.4 1940.4 2500 1250 2500Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask0_15_3)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-518 1239.1L-516.4 1174.1L1250 1250Z"
						fill="#FEFEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-516.7 1184.9L-514 1130.7L1250 1250Z"
						fill="#FDFEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-514.6 1141.6L-510.6 1087.5L1250 1250Z"
						fill="#FCFDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-511.4 1098.3L-506.1 1044.3L1250 1250Z"
						fill="#FBFCFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-507.1 1055.1L-500.5 1001.3L1250 1250Z"
						fill="#FAFCFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-501.8 1012.1L-493.9 958.4L1250 1250Z"
						fill="#F9FBFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-495.4 969.1L-486.2 915.7L1250 1250Z"
						fill="#F8FAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-488 926.4L-477.5 873.2L1250 1250Z"
						fill="#F7FAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-479.6 883.9L-467.7 830.9L1250 1250Z"
						fill="#F6F9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-470.1 841.5L-456.9 788.9L1250 1250Z"
						fill="#F5F8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-459.5 799.4L-445.1 747.1L1250 1250Z"
						fill="#F4F8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-448 757.6L-432.2 705.7L1250 1250Z"
						fill="#F3F7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-435.4 716.1L-418.3 664.6L1250 1250Z"
						fill="#F2F6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-421.8 674.9L-403.5 623.8L1250 1250Z"
						fill="#F1F6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-407.1 634L-387.6 583.4L1250 1250Z"
						fill="#F0F5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-391.5 593.5L-370.8 543.4L1250 1250Z"
						fill="#EFF4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-374.9 553.4L-352.9 503.9L1250 1250Z"
						fill="#EEF3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-357.3 513.8L-334.1 464.8L1250 1250Z"
						fill="#EDF3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-338.8 474.6L-314.4 426.1L1250 1250Z"
						fill="#ECF2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-319.3 435.8L-293.7 388L1250 1250Z"
						fill="#EBF1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-298.8 397.6L-272.1 350.3L1250 1250Z"
						fill="#EAF1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-277.4 359.8L-249.5 313.3L1250 1250Z"
						fill="#E9F0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-255.1 322.6L-226.1 276.7L1250 1250Z"
						fill="#E8EFFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-231.9 285.9L-201.7 240.8L1250 1250Z"
						fill="#E7EFFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-207.8 249.8L-176.6 205.5L1250 1250Z"
						fill="#E6EEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-182.8 214.4L-150.5 170.8L1250 1250Z"
						fill="#E5EDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-157 179.5L-123.6 136.7L1250 1250Z"
						fill="#E4EDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-130.3 145.3L-95.9 103.4L1250 1250Z"
						fill="#E3ECFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-102.7 111.8L-67.3 70.7L1250 1250Z"
						fill="#E2EBFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-74.4 78.9L-38 38.7L1250 1250Z"
						fill="#E1EBFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-45.3 46.8L-7.89999 7.5L1250 1250Z"
						fill="#E0EAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-15.4 15.4L23 -23L1250 1250Z"
						fill="#DFE9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L15.4 -15.4L54.6 -52.7L1250 1250Z"
						fill="#DEE9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L46.8 -45.3L87 -81.7L1250 1250Z"
						fill="#DDE8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L78.9 -74.4L120 -109.8L1250 1250Z"
						fill="#DCE7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L111.8 -102.7L153.7 -137.1L1250 1250Z"
						fill="#DBE7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L145.3 -130.3L188.1 -163.6L1250 1250Z"
						fill="#DAE6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L179.5 -157L223.1 -189.3L1250 1250Z"
						fill="#D9E5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L214.4 -182.8L258.7 -214L1250 1250Z"
						fill="#D8E5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L249.8 -207.8L294.9 -237.9L1250 1250Z"
						fill="#D7E4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L285.9 -231.9L331.8 -260.9L1250 1250Z"
						fill="#D6E3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L322.6 -255.1L369.1 -283L1250 1250Z"
						fill="#D5E3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L359.8 -277.4L407 -304.1L1250 1250Z"
						fill="#D4E2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L397.6 -298.8L445.4 -324.4L1250 1250Z"
						fill="#D3E1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L435.8 -319.3L484.3 -343.6L1250 1250Z"
						fill="#D2E0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L474.6 -338.8L523.6 -361.9L1250 1250Z"
						fill="#D1E0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L513.8 -357.3L563.4 -379.3L1250 1250Z"
						fill="#D0DFFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L553.4 -374.9L603.6 -395.7L1250 1250Z"
						fill="#CFDEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L593.5 -391.5L644.2 -411L1250 1250Z"
						fill="#CEDEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L634 -407.1L685.1 -425.4L1250 1250Z"
						fill="#CDDDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L674.9 -421.8L726.4 -438.7L1250 1250Z"
						fill="#CCDCFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L716.1 -435.4L768 -451.1L1250 1250Z"
						fill="#CBDCFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L757.6 -448L809.9 -462.4L1250 1250Z"
						fill="#CADBFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L799.4 -459.5L852 -472.7L1250 1250Z"
						fill="#C9DAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L841.5 -470.1L894.4 -481.9L1250 1250Z"
						fill="#C8DAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L883.9 -479.6L937 -490.1L1250 1250Z"
						fill="#C7D9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L926.4 -488L979.8 -497.3L1250 1250Z"
						fill="#C6D8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L969.1 -495.4L1022.8 -503.4L1250 1250Z"
						fill="#C5D8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1012.1 -501.8L1065.9 -508.4L1250 1250Z"
						fill="#C4D7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1055.1 -507.1L1109.1 -512.4L1250 1250Z"
						fill="#C3D6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1098.3 -511.4L1152.4 -515.4L1250 1250Z"
						fill="#C2D6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1141.6 -514.6L1195.8 -517.2L1250 1250Z"
						fill="#C1D5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1184.9 -516.7L1239.1 -518L1250 1250Z"
						fill="#C0D4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1228.3 -517.8H1282.5L1250 1250Z"
						fill="#BFD4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1271.7 -517.8L1325.9 -516.4L1250 1250Z"
						fill="#BED3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1315.1 -516.7L1369.2 -514L1250 1250Z"
						fill="#BDD2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1358.4 -514.6L1412.5 -510.6L1250 1250Z"
						fill="#BCD2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1401.7 -511.4L1455.7 -506.1L1250 1250Z"
						fill="#BBD1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1444.8 -507.1L1498.7 -500.5L1250 1250Z"
						fill="#BAD0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1487.9 -501.8L1541.6 -493.9L1250 1250Z"
						fill="#B9D0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1530.8 -495.4L1584.3 -486.2L1250 1250Z"
						fill="#B8CFFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1573.6 -488L1626.8 -477.5L1250 1250Z"
						fill="#B7CEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1616.1 -479.6L1669.1 -467.7L1250 1250Z"
						fill="#B6CDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1658.5 -470.1L1711.1 -456.9L1250 1250Z"
						fill="#B5CDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1700.6 -459.5L1752.8 -445.1L1250 1250Z"
						fill="#B4CCFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1742.4 -448L1794.3 -432.2L1250 1250Z"
						fill="#B3CBFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1783.9 -435.4L1835.4 -418.3L1250 1250Z"
						fill="#B2CBFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1825.1 -421.8L1876.2 -403.5L1250 1250Z"
						fill="#B1CAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1866 -407.1L1916.6 -387.6L1250 1250Z"
						fill="#B0C9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1906.4 -391.5L1956.6 -370.8L1250 1250Z"
						fill="#AFC9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1946.5 -374.9L1996.1 -352.9L1250 1250Z"
						fill="#AEC8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1986.2 -357.3L2035.2 -334.1L1250 1250Z"
						fill="#ADC7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2025.4 -338.8L2073.9 -314.4L1250 1250Z"
						fill="#ACC7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2064.2 -319.3L2112 -293.7L1250 1250Z"
						fill="#ABC6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2102.4 -298.8L2149.7 -272.1L1250 1250Z"
						fill="#AAC5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2140.2 -277.4L2186.7 -249.5L1250 1250Z"
						fill="#A9C5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2177.4 -255.1L2223.2 -226.1L1250 1250Z"
						fill="#A8C4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2214.1 -231.9L2259.2 -201.7L1250 1250Z"
						fill="#A7C3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2250.2 -207.8L2294.5 -176.6L1250 1250Z"
						fill="#A6C3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2285.6 -182.8L2329.2 -150.5L1250 1250Z"
						fill="#A5C2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2320.5 -157L2363.2 -123.6L1250 1250Z"
						fill="#A4C1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2354.7 -130.3L2396.6 -95.9L1250 1250Z"
						fill="#A3C1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2388.2 -102.7L2429.3 -67.3L1250 1250Z"
						fill="#A2C0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2421.1 -74.4L2461.3 -38L1250 1250Z"
						fill="#A1BFFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2453.2 -45.3L2492.5 -7.89999L1250 1250Z"
						fill="#A0BFFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2484.6 -15.4L2523 23L1250 1250Z"
						fill="#9FBEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2515.3 15.4L2552.7 54.6L1250 1250Z"
						fill="#9EBDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2545.3 46.8L2581.7 87L1250 1250Z"
						fill="#9DBDFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2574.4 78.9L2609.8 120L1250 1250Z"
						fill="#9CBCFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2602.7 111.8L2637.1 153.7L1250 1250Z"
						fill="#9BBBFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2630.3 145.3L2663.6 188.1L1250 1250Z"
						fill="#9ABAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2657 179.5L2689.3 223.1L1250 1250Z"
						fill="#99BAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2682.8 214.4L2714 258.7L1250 1250Z"
						fill="#98B9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2707.8 249.8L2737.9 294.9L1250 1250Z"
						fill="#97B8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2731.9 285.9L2760.9 331.8L1250 1250Z"
						fill="#96B8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2755.1 322.6L2783 369.1L1250 1250Z"
						fill="#95B7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2777.4 359.8L2804.1 407L1250 1250Z"
						fill="#94B6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2798.8 397.6L2824.3 445.4L1250 1250Z"
						fill="#93B6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2819.2 435.8L2843.6 484.3L1250 1250Z"
						fill="#92B5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2838.8 474.6L2861.9 523.6L1250 1250Z"
						fill="#91B4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2857.3 513.8L2879.3 563.4L1250 1250Z"
						fill="#90B4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2874.9 553.4L2895.6 603.6L1250 1250Z"
						fill="#8FB3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2891.5 593.5L2911 644.2L1250 1250Z"
						fill="#8EB2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2907.1 634L2925.4 685.1L1250 1250Z"
						fill="#8DB2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2921.7 674.9L2938.7 726.4L1250 1250Z"
						fill="#8CB1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2935.3 716.1L2951.1 768L1250 1250Z"
						fill="#8BB0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2947.9 757.6L2962.4 809.9L1250 1250Z"
						fill="#8AB0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2959.5 799.4L2972.7 852L1250 1250Z"
						fill="#89AFFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2970.1 841.5L2981.9 894.4L1250 1250Z"
						fill="#88AEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2979.5 883.9L2990.1 937L1250 1250Z"
						fill="#87AEFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2988 926.4L2997.3 979.8L1250 1250Z"
						fill="#86ADFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2995.4 969.1L3003.4 1022.8L1250 1250Z"
						fill="#85ACFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3001.8 1012.1L3008.4 1065.9L1250 1250Z"
						fill="#84ACFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3007.1 1055.1L3012.4 1109.1L1250 1250Z"
						fill="#83ABFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3011.4 1098.3L3015.4 1152.4L1250 1250Z"
						fill="#82AAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3014.6 1141.6L3017.2 1195.8L1250 1250Z"
						fill="#81AAFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3016.7 1184.9L3018 1239.1L1250 1250Z"
						fill="#80A9FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3017.7 1228.3V1282.5L1250 1250Z"
						fill="#7FA8FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3017.7 1271.7L3016.4 1325.9L1250 1250Z"
						fill="#7EA7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3016.7 1315.1L3014 1369.2L1250 1250Z"
						fill="#7DA7FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3014.6 1358.4L3010.6 1412.5L1250 1250Z"
						fill="#7CA6FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3011.4 1401.7L3006.1 1455.7L1250 1250Z"
						fill="#7BA5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3007.1 1444.8L3000.5 1498.7L1250 1250Z"
						fill="#7AA5FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L3001.8 1487.9L2993.8 1541.6L1250 1250Z"
						fill="#79A4FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2995.4 1530.8L2986.2 1584.3L1250 1250Z"
						fill="#78A3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2988 1573.6L2977.4 1626.8L1250 1250Z"
						fill="#77A3FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2979.5 1616.1L2967.7 1669.1L1250 1250Z"
						fill="#76A2FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2970.1 1658.5L2956.9 1711.1L1250 1250Z"
						fill="#75A1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2959.5 1700.6L2945.1 1752.8L1250 1250Z"
						fill="#74A1FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2947.9 1742.4L2932.2 1794.3L1250 1250Z"
						fill="#73A0FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2935.3 1783.9L2918.3 1835.4L1250 1250Z"
						fill="#729FFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2921.7 1825.1L2903.5 1876.2L1250 1250Z"
						fill="#719FFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2907.1 1866L2887.6 1916.6L1250 1250Z"
						fill="#709EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2891.5 1906.4L2870.7 1956.6L1250 1250Z"
						fill="#6F9DFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2874.9 1946.5L2852.9 1996.1L1250 1250Z"
						fill="#6E9DFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2857.3 1986.2L2834.1 2035.2L1250 1250Z"
						fill="#6D9CFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2838.8 2025.4L2814.4 2073.9L1250 1250Z"
						fill="#6C9BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2819.2 2064.2L2793.7 2112L1250 1250Z"
						fill="#6B9BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2798.8 2102.4L2772.1 2149.7L1250 1250Z"
						fill="#6A9AFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2777.4 2140.2L2749.5 2186.7L1250 1250Z"
						fill="#6999FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2755.1 2177.4L2726.1 2223.2L1250 1250Z"
						fill="#6899FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2731.9 2214.1L2701.7 2259.2L1250 1250Z"
						fill="#6798FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2707.8 2250.2L2676.6 2294.5L1250 1250Z"
						fill="#6697FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2682.8 2285.6L2650.5 2329.2L1250 1250Z"
						fill="#6597FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2657 2320.5L2623.6 2363.2L1250 1250Z"
						fill="#6496FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2630.3 2354.7L2595.9 2396.6L1250 1250Z"
						fill="#6395FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2602.7 2388.2L2567.3 2429.3L1250 1250Z"
						fill="#6294FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2574.4 2421.1L2538 2461.3L1250 1250Z"
						fill="#6194FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2545.3 2453.2L2507.9 2492.5L1250 1250Z"
						fill="#6093FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2515.3 2484.6L2477 2523L1250 1250Z"
						fill="#5F92FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2484.6 2515.3L2445.4 2552.7L1250 1250Z"
						fill="#5E92FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2453.2 2545.3L2413 2581.7L1250 1250Z"
						fill="#5D91FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2421.1 2574.4L2380 2609.8L1250 1250Z"
						fill="#5C90FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2388.2 2602.7L2346.3 2637.1L1250 1250Z"
						fill="#5B90FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2354.7 2630.3L2311.9 2663.6L1250 1250Z"
						fill="#5A8FFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2320.5 2657L2276.9 2689.3L1250 1250Z"
						fill="#598EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2285.6 2682.8L2241.3 2714L1250 1250Z"
						fill="#588EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2250.2 2707.8L2205 2737.9L1250 1250Z"
						fill="#578DFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2214.1 2731.9L2168.2 2760.9L1250 1250Z"
						fill="#568CFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2177.4 2755.1L2130.9 2783L1250 1250Z"
						fill="#558CFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2140.2 2777.4L2093 2804.1L1250 1250Z"
						fill="#548BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2102.4 2798.8L2054.6 2824.3L1250 1250Z"
						fill="#538AFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2064.2 2819.2L2015.7 2843.6L1250 1250Z"
						fill="#528AFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L2025.4 2838.8L1976.4 2861.9L1250 1250Z"
						fill="#5189FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1986.2 2857.3L1936.6 2879.3L1250 1250Z"
						fill="#5088FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1946.5 2874.9L1896.4 2895.6L1250 1250Z"
						fill="#4F88FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1906.4 2891.5L1855.8 2911L1250 1250Z"
						fill="#4E87FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1866 2907.1L1814.9 2925.4L1250 1250Z"
						fill="#4D86FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1825.1 2921.7L1773.6 2938.7L1250 1250Z"
						fill="#4C86FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1783.9 2935.3L1732 2951.1L1250 1250Z"
						fill="#4B85FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1742.4 2947.9L1690.1 2962.4L1250 1250Z"
						fill="#4A84FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1700.6 2959.5L1647.9 2972.7L1250 1250Z"
						fill="#4984FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1658.5 2970.1L1605.6 2981.9L1250 1250Z"
						fill="#4883FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1616.1 2979.5L1562.9 2990.1L1250 1250Z"
						fill="#4782FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1573.6 2988L1520.2 2997.3L1250 1250Z"
						fill="#4681FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1530.8 2995.4L1477.2 3003.4L1250 1250Z"
						fill="#4581FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1487.9 3001.8L1434.1 3008.4L1250 1250Z"
						fill="#4480FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1444.8 3007.1L1390.9 3012.4L1250 1250Z"
						fill="#437FFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1401.7 3011.4L1347.6 3015.4L1250 1250Z"
						fill="#427FFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1358.4 3014.6L1304.2 3017.2L1250 1250Z"
						fill="#417EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1315.1 3016.7L1260.8 3018L1250 1250Z"
						fill="#407DFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1271.7 3017.7H1217.4L1250 1250Z"
						fill="#3F7DFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1228.3 3017.7L1174.1 3016.4L1250 1250Z"
						fill="#3E7CFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1184.9 3016.7L1130.7 3014L1250 1250Z"
						fill="#3D7BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1141.6 3014.6L1087.5 3010.6L1250 1250Z"
						fill="#3C7BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1098.3 3011.4L1044.3 3006.1L1250 1250Z"
						fill="#3B7AFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1055.1 3007.1L1001.3 3000.5L1250 1250Z"
						fill="#3A79FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L1012.1 3001.8L958.4 2993.8L1250 1250Z"
						fill="#3979FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L969.1 2995.4L915.7 2986.2L1250 1250Z"
						fill="#3878FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L926.4 2988L873.2 2977.4L1250 1250Z"
						fill="#3777FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L883.9 2979.5L830.9 2967.7L1250 1250Z"
						fill="#3677FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L841.5 2970.1L788.9 2956.9L1250 1250Z"
						fill="#3576FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L799.4 2959.5L747.1 2945.1L1250 1250Z"
						fill="#3475FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L757.6 2947.9L705.7 2932.2L1250 1250Z"
						fill="#3375FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L716.1 2935.3L664.6 2918.3L1250 1250Z"
						fill="#3274FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L674.9 2921.7L623.8 2903.5L1250 1250Z"
						fill="#3173FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L634 2907.1L583.4 2887.6L1250 1250Z"
						fill="#3073FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L593.5 2891.5L543.4 2870.7L1250 1250Z"
						fill="#2F72FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L553.4 2874.9L503.9 2852.9L1250 1250Z"
						fill="#2E71FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L513.8 2857.3L464.8 2834.1L1250 1250Z"
						fill="#2D71FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L474.6 2838.8L426.1 2814.4L1250 1250Z"
						fill="#2C70FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L435.8 2819.2L388 2793.7L1250 1250Z"
						fill="#2B6FFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L397.6 2798.8L350.3 2772.1L1250 1250Z"
						fill="#2A6EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L359.8 2777.4L313.3 2749.5L1250 1250Z"
						fill="#296EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L322.6 2755.1L276.7 2726.1L1250 1250Z"
						fill="#286DFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L285.9 2731.9L240.8 2701.7L1250 1250Z"
						fill="#276CFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L249.8 2707.8L205.5 2676.6L1250 1250Z"
						fill="#266CFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L214.4 2682.8L170.8 2650.5L1250 1250Z"
						fill="#256BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L179.5 2657L136.7 2623.6L1250 1250Z"
						fill="#246AFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L145.3 2630.3L103.4 2595.9L1250 1250Z"
						fill="#236AFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L111.8 2602.7L70.7 2567.3L1250 1250Z"
						fill="#2269FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L78.9 2574.4L38.7 2538L1250 1250Z"
						fill="#2168FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L46.8 2545.3L7.5 2507.9L1250 1250Z"
						fill="#2068FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L15.4 2515.3L-23 2477L1250 1250Z"
						fill="#1F67FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-15.4 2484.6L-52.7 2445.4L1250 1250Z"
						fill="#1E66FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-45.3 2453.2L-81.7 2413L1250 1250Z"
						fill="#1D66FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-74.4 2421.1L-109.8 2380L1250 1250Z"
						fill="#1C65FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-102.7 2388.2L-137.1 2346.3L1250 1250Z"
						fill="#1B64FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-130.3 2354.7L-163.6 2311.9L1250 1250Z"
						fill="#1A64FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-157 2320.5L-189.3 2276.9L1250 1250Z"
						fill="#1963FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-182.8 2285.6L-214 2241.3L1250 1250Z"
						fill="#1862FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-207.8 2250.2L-237.9 2205L1250 1250Z"
						fill="#1762FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-231.9 2214.1L-260.9 2168.2L1250 1250Z"
						fill="#1661FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-255.1 2177.4L-283 2130.9L1250 1250Z"
						fill="#1560FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-277.4 2140.2L-304.1 2093L1250 1250Z"
						fill="#1460FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-298.8 2102.4L-324.4 2054.6L1250 1250Z"
						fill="#135FFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-319.3 2064.2L-343.6 2015.7L1250 1250Z"
						fill="#125EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-338.8 2025.4L-361.9 1976.4L1250 1250Z"
						fill="#115EFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-357.3 1986.2L-379.3 1936.6L1250 1250Z"
						fill="#105DFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-374.9 1946.5L-395.7 1896.4L1250 1250Z"
						fill="#0F5CFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-391.5 1906.4L-411 1855.8L1250 1250Z"
						fill="#0E5BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-407.1 1866L-425.4 1814.9L1250 1250Z"
						fill="#0D5BFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-421.8 1825.1L-438.7 1773.6L1250 1250Z"
						fill="#0C5AFF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-435.4 1783.9L-451.1 1732L1250 1250Z"
						fill="#0B59FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-448 1742.4L-462.4 1690.1L1250 1250Z"
						fill="#0A59FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-459.5 1700.6L-472.7 1647.9L1250 1250Z"
						fill="#0958FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-470.1 1658.5L-481.9 1605.6L1250 1250Z"
						fill="#0857FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-479.6 1616.1L-490.1 1562.9L1250 1250Z"
						fill="#0757FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-488 1573.6L-497.3 1520.2L1250 1250Z"
						fill="#0656FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-495.4 1530.8L-503.4 1477.2L1250 1250Z"
						fill="#0555FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-501.8 1487.9L-508.4 1434.1L1250 1250Z"
						fill="#0455FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-507.1 1444.8L-512.4 1390.9L1250 1250Z"
						fill="#0354FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-511.4 1401.7L-515.4 1347.6L1250 1250Z"
						fill="#0253FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-514.6 1358.4L-517.2 1304.2L1250 1250Z"
						fill="#0153FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-516.7 1315.1L-518 1260.8L1250 1250Z"
						fill="#0052FF"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1250 1250L-517.8 1271.7V1228.3L1250 1250Z"
						fill="white"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_15_3">
					<rect width="2500" height="2500" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
